module.exports = __webpack_public_path__ + "img/x.d71cc4a9.svg";